import { copyToClipBoard } from "helpers/utils";

const jsonSchema = [
  {
    type: 'group',
    fields: [
      {
        name: 'name',
        label: 'Name',
        required: true,
        showInList: true,
        type: 'text'
      },
      {
        name: 'dob',
        label: 'Date of Birth',
        type: 'date',
        pattern: 'dd/MM/yyyy'
      },
      {
        name: 'lastContact',
        label: 'Last Contact',
        type: 'date'
      }
    ]
  },
  {
    type: 'group',
    fields: [
      {
        name: 'where',
        label: 'Where did I meet them?',
        type: 'multiselect',
        required: true,
        showInList: true,
        isMulti: false
      },
      {
        name: 'who',
        label: 'Who did I meet?',
        type: 'multiselect',
        required: false,
        showInList: true,
        isMulti: false
      },
      {
        name: 'email',
        label: 'Email',
        type: 'text',
        required: false,
        showInList: true,
        copyToClipBoard: true
      }
    ]
  },
  {
    name: 'context',
    label: 'Context',
    type: 'textarea',
    required: false,
    showInList: false
  },
  {
    name: 'interests',
    label: 'Interests/Tastes',
    type: 'creatableselect',
    isMulti: true
  },
  {
    name: 'pains',
    label: 'Pains/Necessities',
    type: 'editor'
  }
];
export default jsonSchema;
